export const promoBanners = {
  promoBannerAlt: "Promotional banner",
  promoBannerSlide: "Slide",
  tagDrop: "Drop",
  tagTorneo: "Tournament",
  tagRace: "Race",
  tagNuevo: "New",
  tagPromo: "Promo",
};
